import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './app/App';
import reportWebVitals from './reportWebVitals';
import { AnalyticsProvider } from 'lib/analytics/posthog';
import { loadRuntimeConfig } from './config/runtimeConfig';

const bootstrap = async () => {
  await loadRuntimeConfig();
  // eslint-disable-next-line no-undef
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <AnalyticsProvider>
        <App />
      </AnalyticsProvider>
    </React.StrictMode>
  );
};

void bootstrap();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
